// 海运相关 getters
import calc from 'calculatorjs'

export const getters = {
  // 是否可以使用海运
  seaInfo (state, getters, rootState) {
    const prepare = state.createPrepare
    // 家具
    const isFurniture = prepare.parcels.every((parcel) =>
      parcel.extraInfo.tpTaobaoTradeItems.find(
        (tpItem) => tpItem.itemMold && tpItem.itemMold.indexOf('4') === 0
      )
    )

    const isLgFragile = prepare.parcels.every((parcel) =>
      parcel.extraInfo.hasLgFragile
    )

    // 1-6類
    const isMold6x = prepare.parcels.every((parcel) =>
      parcel.extraInfo.tpTaobaoTradeItems.find(
        (tpItem) => tpItem.itemMold && tpItem.itemMold.indexOf('6') === 0 && tpItem.itemCccCode && tpItem.itemCnCode
      )
    )

    // 是否同時混雜了家具(mold 4)與海運雜貨(mold 6)的商品，混雜時不允許走海運
    const hasMold4Item = prepare.parcels.some((parcel) =>
      parcel.extraInfo.tpTaobaoTradeItems.some(
        (tpItem) => tpItem.itemMold && tpItem.itemMold.indexOf('4') === 0
      )
    )
    const hasMold6Item = prepare.parcels.some((parcel) =>
      parcel.extraInfo.tpTaobaoTradeItems.some(
        (tpItem) => tpItem.itemMold && tpItem.itemMold.indexOf('6') === 0
      )
    )
    const hasMixedMold = hasMold4Item && hasMold6Item

    const isSeaAddr = rootState.parcel.seaAddrids.includes(
      prepare.parcelsInfo.jyAddrid
    )
    const ccnames = [
      ...new Set(
        prepare.parcels[0].extraInfo.tpTaobaoTradeItems
          .map((item) => item.itemCcName)
          .filter((item) => item)
      ),
    ]
    const isSameCcname = prepare.parcels.every((parcel) => {
      const ccnames2 = [
        ...new Set(
          parcel.extraInfo.tpTaobaoTradeItems
            .map((item) => item.itemCcName)
            .filter((item) => item)
        ),
      ]
      return (
        ccnames.length === ccnames2.length &&
        ccnames.every((ccname) => ccnames2.includes(ccname))
      )
    })

    const itemMolds = []
    prepare.parcels.forEach(parcel => {
      parcel.extraInfo.tpTaobaoTradeItems
        .map((item) => item.itemMold)
        .filter((item) => item?.indexOf('6') === 0)
        .forEach(mold => {
          if (!itemMolds.includes(mold)) {
            itemMolds.push(mold)
          }
        })
    })
    // 倒序排序,从大到小
    itemMolds.sort((a, b) => b - a)
    let srLabel = 'ITEMMOLD4'
    if (isMold6x) {
      srLabel = `ITEMMOLD${itemMolds[0]}`
    }
    if (isLgFragile) {
      srLabel = 'LGFRAGILE'
    }
    console.log('itemMolds', itemMolds)
    const seaHasVoucher = prepare.parcels.every(parcel => parcel.extraInfo.seaHasVoucher)

    let moldAuditStatus = ''
    if (
      !isFurniture &&
      prepare.parcels.every((parcel) =>
        parcel.extraInfo.tpTaobaoTradeItems.find(
          (tpItem) => tpItem.itemStyle === 'NON_JJU'
        )
      )
    ) {
      moldAuditStatus = 'reject'
    }
    if (
      !isFurniture &&
      !isLgFragile &&
      moldAuditStatus !== 'reject' && seaHasVoucher && !prepare.parcels.every((parcel) =>
        parcel.extraInfo.tpTaobaoTradeItems.find(
          (tpItem) => tpItem.itemMold && tpItem.itemCccCode && tpItem.itemCnCode
        )
      )) {
      moldAuditStatus = 'pending' // 审核中
    }

    let canApplySea = false
    // 1、子母单總計要超過70KG，或超過8才。不限制單個包裹重量。
    // 3、非子母單單件超過60KG，或體積超過8才

    // 非子母單
    canApplySea = prepare.parcels.filter(parcel => !(parcel.tnoPriCount > 1)).every(parcel => parcel.weight >= 60000 || parcel.cai27s >= 8)

    // 子母單
    const tnoPriParcels = prepare.parcels.filter(parcel => parcel.tnoPriCount > 1)
    if (tnoPriParcels.length) {
      canApplySea = canApplySea && (tnoPriParcels.reduce((pre, cur) => {
        return calc.add(pre, cur.weight)
      }, 0) >= 70000 || tnoPriParcels.reduce((pre, cur) => {
        return calc.add(pre, cur.cai27s || 0)
      }, 0) >= 8)
    }
    if (isLgFragile) {
      canApplySea = true
    }

    const canSea = isSeaAddr &&
      (isFurniture || (isMold6x && canApplySea)) // 必须转一般仓的重量和体积才能下单海运杂货

    return {
      isFurniture,
      isMold6x,
      // isFragile,
      moldAuditStatus, // 审核状态 reject | pass | ''
      isSameCcname,
      isSeaAddr,
      canSea,
      srLabel,
      itemMolds,
      canApplySea,
      seaHasVoucher,
      isLgFragile,
      hasMixedMold,
    }
  },
  seaParcelsFeeInfo (state, getters, rootState) {
    const prepare = state.createPrepare
    const parcels = prepare.parcels

    const map = {}
    parcels.forEach(parcel => {
      const itemMold = parcel.extraInfo.tpTaobaoTradeItems.find(item => item.itemMold?.indexOf('6') === 0 || item.itemMold?.indexOf('4') === 0 || parcel.extraInfo.hasLgFragile)?.itemMold
      if (itemMold) {
        // 海杂
        let sr = prepare.shippingRates.find(sr => sr.srLabel === `ITEMMOLD${itemMold}`)
        if (!sr && itemMold.indexOf('4') === 0) {
          // 家具
          sr = prepare.shippingRates.find(sr => sr.transport === 'sea' && sr.srLabel === 'ITEMMOLD4')
        }
        if (parcel.extraInfo.hasLgFragile) {
          sr = prepare.shippingRates.find(sr => sr.transport === 'sea' && sr.srLabel === 'LGFRAGILE')
        }
        if (getters.isBizeco) {
          sr = getters.shippingRatesInfo
        }
        if (sr) {
          map[parcel.trackingNo] = sr.parcelsFeeFormulas[parcel.trackingNo]
        }
      }
    })

    const parcelsFee = parcels.reduce((pre, cur) => {
      const formula = map[cur.trackingNo]
      if (!formula) {
        return pre
      }
      if (formula.cai28Fees && formula.cai28Fees[4] > formula.wtFees[4]) {
        return calc.add(pre, formula.cai28Fees[4])
      }
      return calc.add(pre, formula.wtFees[4])
    }, 0)
    return {
      formulasMap: map,
      parcelsFee,
    }
  },
}
